import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn';
export function FilterPills({ options, value, onChange, label, className, variant = 'standalone', size = 'console', }) {
    const segmented = variant === 'segmented';
    const member = size === 'member';
    return (_jsx("div", { role: "radiogroup", "aria-label": label, className: cn(segmented
            ? 'inline-flex flex-wrap items-center gap-1 rounded-pill border border-border bg-card p-1'
            : 'flex flex-wrap items-center gap-2', className), children: options.map((option) => {
            const active = option.value === value;
            const disabled = option.disabled === true;
            return (_jsx("button", { type: "button", role: "radio", "aria-checked": active, disabled: disabled, "aria-disabled": disabled || undefined, ...(option.unavailableReason === undefined
                    ? {}
                    : { title: option.unavailableReason, 'aria-description': option.unavailableReason }), onClick: () => {
                    if (disabled)
                        return;
                    onChange(option.value);
                }, className: cn('rounded-pill font-brand font-semibold transition-colors', member
                    ? 'shrink-0 whitespace-nowrap border-[1.5px] px-4 py-[9px] text-sm'
                    : cn('text-[12.5px]', segmented ? 'h-[30px] border-0 px-[14px]' : 'h-[34px] border px-[14px]'), disabled
                    ? cn('cursor-not-allowed text-muted-foreground/60', segmented ? 'bg-transparent' : 'border-dashed border-border bg-transparent')
                    : active
                        ? cn('bg-primary text-primary-foreground', segmented ? '' : 'border-primary')
                        : cn(member
                            ? 'text-text-body hover:text-foreground'
                            : 'text-muted-foreground hover:text-foreground', 
                        // Transparent over the track, rather than a second white card on top of it.
                        segmented ? 'bg-transparent' : 'border-border bg-card')), children: option.label }, option.value));
        }) }));
}
//# sourceMappingURL=filter-pills.js.map